import { DeviceLogsPage } from "fleet/view/device/logs";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { applicationsSelector } from "redux-store/applications/selectors";
import { GET_LOGS_DEVICE } from "redux-store/devices/actions";
import * as FeatureFlags from "redux-store/feature-flags/selectors";
import { storesReady } from "redux-store/utils";

function mapStateToProps(state, props) {
  const { device, storesLoaded: parentStoresLoaded } = props;

  const storesLoaded =
    storesReady(state.global.applications) && parentStoresLoaded;
  const applications = applicationsSelector(state);
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  return {
    applications,
    device,
    storesLoaded,
    featureFlags,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchDeviceLogs: (serviceArgs) => {
      const { deviceId, level, start, end } = serviceArgs;

      return createPromiseApiAction(dispatch, GET_LOGS_DEVICE, [
        deviceId,
        level,
        start,
        end,
      ]);
    },
  };
}

const ConnectedDeviceLogsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceLogsPage);

export { ConnectedDeviceLogsPage };
